import GlobalStyle from "./style/GlobalStyle";
import Home from "./page/Home";

function App() {
  return (
    <>
      <GlobalStyle />
      <Home />
    </>
  );
}

export default App;
